module.exports = __webpack_public_path__ + "static/img/naturalessentialoil.f9e5d348.jpg";